import * as http from '../helpers/http';

class ParlamentarDiscursoService {

    GetList = async (id: number, filtro: any, pageIndex: number, pageSize: number = 8): Promise<any> => {
        const result = await http.get(`/parlamentar/${id}/discursos?filter=${JSON.stringify(filtro)}&pageSize=${pageSize}&pageIndex=${pageIndex}`);
        if (result.success) {
            return {
                success: true,
                listInfo: {
                    pageSize: result.data.pageSize,
                    pageIndex: result.data.pageIndex,
                    pageItens: result.data.pageItens,
                    totalItens: result.data.totalItens,
                    totalPages: result.data.totalPages
                },
                lista: result.data.data
            }
        }
        return undefined;
    }

    GetSummary = async (id: number, filtro: any): Promise<any> => {
        const result = await http.get(`/parlamentar/${id}/discursos/summary?filter=${JSON.stringify(filtro)}`);
        if (result.success) {
            return result.data;
        }
        return undefined;
    }

    GetTranscricao = async (id: number): Promise<any> => {
        const result = await http.get(`/parlamentar/discursos/${id}/transcricao`);
        if (result.success) {
            return result.data;
        }
        return undefined;
    }


    Create = async (data: any, id: number): Promise<any> => {
        const result = await http.post(`/parlamentar/${id}/discursos`, data);
        if (result.success) { return result.data }
        return 0;
    }

    SetQualificacao = async (id: number, qualificacao: string): Promise<any> => {
        const result = await http.put(`/parlamentar/discursos/${id}/qualificacao`, { qualificacao: qualificacao });
        if (result.success) { return result.data }
        return undefined;
    }

    Delete = async (id: number): Promise<boolean> => {
        const result = await http.del(`/parlamentar/discursos/${id}`);
        if (result.success) { return true }
        return false;
    };
}
export default new ParlamentarDiscursoService();
